import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const PPSL_AUDITS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('PPSL_AUDITS');
export const PPSL_AUDITS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	PPSL_AUDITS_CRUD_ACTION_CONSTANTS
);
